import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LightningIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.34 2 2 12h7.5l-.83 6.67 8.33-10H9.5L10.34 2Z"
      />
    </Icon>
  );
}
